<template>
  <div class="home">
    <van-nav-bar left-text="上社保 找亿企评">
      <a :href="'tel:' + phone" slot="right" class="hd-title"><i class="tel-icon"></i>{{phone}}</a>
    </van-nav-bar>

    <van-swipe :show-indicators="false" :autoplay="0">
      <van-swipe-item>
        <div class="banner">
          <h3>五险一金代缴服务</h3>
          <h4>24小时自助缴纳&nbsp;&nbsp;&nbsp;&nbsp;覆盖全国200+城市</h4>
          <h4>拼团价低至3.5折&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;缴纳方案自由选择</h4>
        </div>
      </van-swipe-item>
    </van-swipe>

    <section class="social-scheme">
      <Title :title="msg1" :subTitle="subMsg"></Title>
      <div class="scheme-list v-flex">
        <div class="scheme-item" v-for="(item, index) in schemeList" :key="index">
          <div class="scheme-box">
            <img :src="item.icon" alt="">
            <h5>{{item.title}}</h5>
          </div>
        </div>
      </div>
    </section>

    <section class="social-process">
      <Title :title="msg2"></Title>
      <div class="process-list v-flex">
        <div class="process-item bg-1">
          <div class="process-num">01</div>
          <img src="../../assets/img/icon-city.png" alt="">
          <h5>确定参保城市</h5>
        </div>
        <div class="process-item bg-2">
          <div class="process-num">02</div>
          <img src="../../assets/img/icon-cycle.png" alt="">
          <h5>确定参保周期</h5>
        </div>
        <div class="process-item bg-3">
          <div class="process-num">03</div>
          <img src="../../assets/img/icon-type.png" alt="">
          <h5>确定参保类型</h5>
        </div>
        <div class="process-item bg-4">
          <div class="process-num">04</div>
          <img src="../../assets/img/icon-dock.png" alt="">
          <h5>参保对接</h5>
        </div>
      </div>
    </section>


    <section class="social-methods" id="selfInsurance">
      <Title :title="msg7"></Title>
      <div class="self-tips"><img src="../../assets/img/speaker.png" alt="">下单后请注意接听我们电话，开票请对接客服</div>
      <div class="self-insurance">
        <van-cell-group class="selectBox dropArrow">
          <van-field
            :value="areaValue"
            label="参保城市"
            right-icon="play"
            placeholder="请选择参保城市"
            @click.stop.prevent="openAreaPopup"
            disabled
          />
          <van-field
            :value="insContValue"
            label="参保内容"
            right-icon="play"
            placeholder="请选择参保内容"
            @click.stop.prevent="openInsContPopup"
            disabled
          />
          <van-field
            v-model="contactTel"
            label="联系人"
            type="tel"
            placeholder="请输入手机号"
            clearable
            @input="hidePayDetail"
          />
        </van-cell-group>

        <div class="addSocialMember" v-for="(item, index) in socialList" :key="index">
          <h4>参保人{{item.id+1}}:</h4>
          <div class="addSocialItem v-flex">
            <van-cell-group>
              <van-field
                v-model="item.socialName"
                label="姓名"
                placeholder="请输入姓名"
                clearable
                style="padding-right: 20px;box-sizing: border-box"
                @input="hidePayDetail"
              />
            </van-cell-group>
            <van-cell-group class="selectBox dropArrow">
              <van-field
                :value="item.fwnr"
                clearable
                label="服务内容"
                right-icon="play"
                placeholder="请选择服务内容"
                @click.stop.prevent="openServerPopup(index)"
                disabled
              />
            </van-cell-group>
          </div>
          <van-cell-group>
            <van-field
              v-model="item.idcard"
              label="身份证号"
              placeholder="请输入身份证号"
              clearable
              @input="hidePayDetail"
            />
          </van-cell-group>
          <div class="addSocialItem v-flex">
            <van-cell-group class="selectBox">
              <van-field
                :value="item.startDate"
                label="参保时间"
                right-icon="calender-o"
                placeholder="从"
                @click.stop.prevent="openDatePopup(0, index)"
                disabled
              />
            </van-cell-group>
            <span class="default-line">-</span>
            <van-cell-group class="selectBox">
              <van-field
                :value="item.endDate"
                right-icon="calender-o"
                placeholder="至"
                @click.stop.prevent="openDatePopup(1, index)"
                disabled
              />
            </van-cell-group>
          </div>
          <van-cell-group class="selectBox dropArrow" v-if="showPrice">
            <van-field
              :value="item.priceType"
              clearable
              label="缴纳类型"
              right-icon="play"
              placeholder="请选择缴纳类型"
              @click.stop.prevent="openPricePopup(index)"
              disabled
            />
          </van-cell-group>
        </div>

        <div class="addSocialBtn">
          <van-button size="small" type="info" @click="addMembers">添加参保人+</van-button>
        </div>

        <div class="sureSocialBtn">
          <van-button size="small" type="info" @click="sureInsInfo">确定参保信息</van-button>
        </div>

        <div class="canbaoInfo" v-if="sureCbInfo">
          <div class="social-pay">
            <h4><span class="detail-label">参保确认：</span>{{cityName}}</h4>
            <h4><span class="detail-label">参保内容：</span>{{insContValue}}</h4>
            <h4><span class="detail-label">联系人：</span>{{contactTel}}</h4>
            <ul class="payDetailList clearfix" v-for="(item, index) in socialList" :key="index">
              <li>{{item.socialName}}</li>
              <li class="w-240">{{item.idcard}}</li>
              <li>{{item.monthNum}}个月</li>
              <li class="w-88">{{item.fwnr}}</li>
              <li class="w-88">{{item.priceType}}</li>
            </ul>
            <h4>费用合计：</h4>
            <h5><span class="detail-label">代收费用：</span><span>¥{{charge}}</span></h5>
            <h5><span class="detail-label">服务费：</span><span>¥{{serviceCharge}}</span></h5>
            <h4><span class="detail-label">费用合计：</span><span class="totalNum">¥{{totalPrice}}</span></h4>
            <van-checkbox v-model="checked">同意《亿企评服务协议》</van-checkbox>
          </div>

          <div class="sureSocialBtn">
            <van-button size="small" type="info" @click="toPay">去支付</van-button>
          </div>
        </div>

        <!--<div class="canbaoTips">
          <h5>**{{tips}}***</h5>
        </div>-->

      </div>
    </section>

    <section class="social-advant">
      <Title :title="msg4"></Title>
      <div class="advant-list v-flex">
        <div class="advant-item">
          <div class="advant-box advant-bg-1">权威认证<br/>资质无忧</div>
        </div>
        <div class="advant-item">
          <div class="advant-box advant-bg-2">城市<br/>覆盖200+</div>
        </div>
        <div class="advant-item">
          <div class="advant-box advant-bg-3">口碑好评率<br/>98%</div>
        </div>
        <div class="advant-item">
          <div class="advant-box advant-bg-4">社会公积金<br/>自由缴纳</div>
        </div>
        <div class="advant-item">
          <div class="advant-box advant-bg-5">实惠安全<br/>行业标杆</div>
        </div>
        <div class="advant-item">
          <div class="advant-box advant-bg-6">优质服务<br/>专业高效</div>
        </div>
      </div>
    </section>

    <section class="social-tips">
      <h4>温馨提示</h4>
      <div class="tips-text">
        <p>1、因您自身原因(未了解清楚规则、无故撤单)退费的，服务费不予退还!</p>
        <p>2、如曾在单位参保，请您务必在亿企评办理截止日前确认上家单位已经停保，因前单位未停保导致业务办理不成功，本平台概不负责。</p>
        <p>3、亿企评不承接正住院、患病及已怀孕等特殊人员的代缴服务，如隐瞒孕情、病情下单，相应社保待遇将无法申请办理。</p>
        <p>4、亿企评提供社保公积金代缴服务，服务内容不包含劳动合同或涉及劳动关系证明的办理。</p>
      </div>
    </section>

    <section class="social-media">
      <Title :title="msg5"></Title>
      <div class="advant-list v-flex">
        <div class="advant-item">
          <img src="../../assets/img/media_1.png" alt="阿里巴巴">
        </div>
        <div class="advant-item">
          <img src="../../assets/img/media_2.png" alt="网易">
        </div>
        <div class="advant-item">
          <img src="../../assets/img/media_3.png" alt="百度">
        </div>
        <div class="advant-item">
          <img src="../../assets/img/media_4.png" alt="360">
        </div>
        <div class="advant-item">
          <img src="../../assets/img/media_5.png" alt="今日头条">
        </div>
        <div class="advant-item">
          <img src="../../assets/img/media_6.png" alt="CCTV">
        </div>
        <div class="advant-item">
          <img src="../../assets/img/media_7.png" alt="新浪微博">
        </div>
        <div class="advant-item">
          <img src="../../assets/img/media_8.png" alt="腾讯">
        </div>
      </div>
    </section>

    <section class="social-about">
      <Title :title="msg6"></Title>
      <div class="about-box">
        <h5>亿企评企业服务有限公司</h5>
        <p>亿企评专注于自由职业者、个体工商户、小微企业、全国性跨区域企业提供一站式社保、公积金代缴平台，为客户解决地方性社保公积金问题，可自由选择代缴服务，以优质高效的专业服务为全国人民提供。</p>
        <div class="advant-list v-flex">
          <div class="advant-item">
            <img src="../../assets/img/company_1.png" alt="">
          </div>
          <div class="advant-item">
            <img src="../../assets/img/company_2.png" alt="">
          </div>
          <div class="advant-item">
            <img src="../../assets/img/company_3.png" alt="">
          </div>
        </div>
      </div>
    </section>

    <section class="social-copyright">
      <h4>版权所有亿企评企业服务有限公司</h4>
    </section>

    <footer class="footer v-flex">
      <div class="foot-item text-center" @click="gotoOrder">
        <h5 style="line-height: 3">自助缴纳</h5>
      </div>
      <div class="foot-item yellow text-center">
        <a :href="'tel:' + phone">
          <h5>电话咨询<br/>{{phone}}</h5>
        </a>
      </div>
    </footer>


    <!--参保城市-->
    <van-popup v-model="areaVisible" position="bottom">
      <van-picker
        show-toolbar
        :columns="areaList"
        value-key="name"
        item-height="1rem"
        @confirm="sureArea"
        @cancel="closePopup"
        @change="selectArea"
      />
    </van-popup>
    <!--参保内容-->
    <van-popup v-model="insContVisible" position="bottom">
      <van-picker
        show-toolbar
        :columns="insContList"
        value-key="name"
        item-height="1rem"
        @confirm="sureInsCont"
        @cancel="closeInsCont"
        @change="selectInsCont"
      />
    </van-popup>
      <!--服务内容-->
      <van-popup v-model="ServiceVisible" position="bottom">
        <van-picker
          show-toolbar
          :columns="fwnrList"
          value-key="name"
          item-height="1rem"
          @confirm="sureService"
          @cancel="closeService"
          @change="selectService"
        />
    </van-popup>

    <!--参保时间-->
    <van-popup v-model="DateVisible" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        item-height="1rem"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="sureDate"
        @cancel="closeDate"
        @change="changeDate(number, arguments)"
      />
    </van-popup>

    <!--缴费类型-->
    <van-popup v-model="priceVisible" position="bottom">
      <van-picker
        show-toolbar
        :columns="priceList"
        value-key="childName"
        item-height="1rem"
        @confirm="surePrice"
        @cancel="closePrice"
        @change="selectPrice"
      />
    </van-popup>

  </div>
</template>

<script>
  import Qs from 'qs'
  import Title from '../../components/Title/Title'
  export default {
    name: 'Home',
    components: {
      Title
    },
    data () {
      return {
        phone: '400-110-9919',
        msg1: '无论您是哪种原因',
        subMsg: '亿企评都能帮您搞定',
        msg2: '参保流程',
        msg4: '亿企评的优势',
        msg5: '认证媒体',
        msg6: '关于我们',
        msg7: '自助参保',
        schemeList: [{
          icon: require("@/assets/img/scheme_1.png"),
          title: '领养老金'
        }, {
          icon: require("@/assets/img/scheme_2.png"),
          title: '买房资格'
        }, {
          icon: require("@/assets/img/scheme_3.png"),
          title: '孩子入学'
        }, {
          icon: require("@/assets/img/scheme_4.png"),
          title: '医疗保障'
        }, {
          icon: require("@/assets/img/scheme_5.png"),
          title: '买车需求'
        }, {
          icon: require("@/assets/img/scheme_6.png"),
          title: '积分办理'
        }, {
          icon: require("@/assets/img/scheme_7.png"),
          title: '异地高考'
        }, {
          icon: require("@/assets/img/scheme_8.png"),
          title: '出国签证'
        }],
        areaVisible: false, //初始选择地区弹窗为关闭状态
        areaList: [{                       //一级：省
          values: ["北京市"],
          className: 'column1',
          textAlign: 'center',
          defaultIndex: 0
        }, {                    //二级：市
          values: ['市辖区'],
          className: 'column2',
          textAlign: 'center',
          defaultIndex: 0
        }],
        areaValue:"请选择省-请选择市", //页面上显示的内容
        cityName:"",//最终选中的地区的名字
        cityCode:"",//最终选中的地区的id
        insContVisible: false,
        insContValue: "",  //参保内容显示的内容
        insContId: "",
        insContList: [{
          id: 0,
          name: "请选择"
        },{
          id: 1,
          name: "五险+公积金"
        },{
          id: 2,
          name: "公积金"
        },{
          id: 3,
          name: "五险"
        }],
        contactTel: "",
        curSerIndex: "",
        socialList: [{
          id: 0,
          socialName: "",
          fwnr: "",
          fwnrId: "",
          idcard: "",
          startDate: "",
          endDate: "",
          monthNum: "",
          priceType: "",
          priceTypeId: ""
        }],
        ServiceVisible: false,
        fwnrList: [{
          id: 0,
          name: "请选择"
        },{
          id: 1,
          name: "新参保"
        },{
          id: 2,
          name: "续缴"
        }],
        number: 0, //区分是0开始日期还是1结束日期
        DateVisible: false,
        currentDate: new Date(),
        minDate: new Date(1970, 0, 1),
        maxDate: new Date(3000, 11, 31),
        showPrice: false, //缴费类型是否显示
        priceList: [], //缴费类型数据
        priceVisible: false, //缴费类型选框是否显示
        colIndex: 0, //初始化下拉选择框
        sureCbInfo: false,
        charge: "", //代收费用
        serviceCharge: "", //服务费
        totalPrice: "", //合计费用
        tips: "",
        checked: true
      }
    },
    methods: {
      formatter(type, value) {
        if (type === 'year') {
          return `${value}年`;
        } else if (type === 'month') {
          return `${value}月`
        }
        return value;
      },
      gotoOrder() {
        //实现锚点定位及跳转（url不发生变化） scrollIntoView(true)没有动画
        document.querySelector("#selfInsurance").scrollIntoView({
          behavior: "smooth"
        });
      },
      openAreaPopup() {
        //打开选择地区的弹窗
        let that = this;
        that.areaVisible = true;
      },
      closePopup() {
        //关闭弹窗
        let that = this;
        that.areaVisible = false;
      },
      sureArea(values) {
        /*console.log("城市确认值：",values[0]);*/
        //确定地区
        let that = this;
        if(values[0].name) {
          if (that.cityName == '') {
            that.cityName = `${values[0].name}-${values[0].cities[0].name}`
          }
          if (that.cityCode == '') {
            that.cityCode = {
              province: values[0].id,
              city: values[0].cities[0].id
            };
          }
          that.areaValue = that.cityName;
          /*console.log(that.cityCode);*/
          let params = {
            cityId: that.cityCode.city
          };
          let strParams = Qs.stringify(params);
          //获取缴费类型
          this.$Api.getPriceTypeList(strParams).then(res => {
            //console.log(res);
            if(res.code == 200){
              this.showPrice = true;
              this.priceList = res.cityConfigList;
            } else {
              this.showPrice = false;
              this.priceList = [];
            }
          }).catch(err => {
            this.$toast("服务器错误，请稍后重试！");
          });
        } else {
          this.$toast("服务器错误，请稍后重试！");
        }
        that.areaVisible = false;
        that.sureCbInfo = false;
      },
      getCityData() {
        //获取城市数据
        let that = this;
        //因为我们需要拿到axios请求的数据，来进行下一个axios的请求，
        //所以我们这里使用promise对象，将异步转换为同步。
        let promise = new Promise(function (resolve, reject) {
          /*that.$Api.getCityList().then(res => {
            resolve(res.areaJson);
            /!*console.log(res.areaJson);*!/
            that.areaList[0].values = res.areaJson;  //绑定省份数据
          }).catch(err => {
            this.$toast("数据发生错误，请稍后再试!");
          });*/
          that.$Api.getCityList().then(res => {
            if(res.code == 200) {
              /*console.log(res.viewCityConfigVOList);*/
              resolve(res.viewCityConfigVOList);
              that.areaList[0].values = res.viewCityConfigVOList;  //绑定省份数据
            } else {
              that.$toast(`${res.msg}`);
            }
          }).catch(err => {
            that.$toast("服务器发生错误，请稍后再试!");
          });
        });
        return promise;
      },
      selectArea(picker, values) {
        //城市的picker改变时调用
        let that = this;
        /*console.log("picker",picker);
        console.log("values",values);*/
        if (values[0].cities) {
          picker.setColumnValues(1, values[0].cities); //将市的地区列表放入 areaList的二级列表中
        }
        let arr = picker.getValues();
        /*console.log(arr);*/
        that.cityName = `${arr[0].name}-${arr[1].name}`;
        that.cityCode = {
          province: arr[0].id,
          city: arr[1].id
        };
      },
      openInsContPopup() {
        let that = this;
        that.insContVisible = true;
      },
      selectInsCont(picker, values) {
        /*console.log("picker",picker);
        console.log("values",values);*/
        this.insContValue = `${values.name}`;
        this.insContId = values.id;
        /*console.log(this.insContValue, this.insContId);*/
      },
      closeInsCont() {
        let that = this;
        that.insContVisible = false;
      },
      sureInsCont(values) {
        let that = this;
        if (that.insContValue == '') {
          that.insContValue = values.name;
        }
        if (that.insContId == '') {
          that.insContId = values.id;
        }
        that.insContVisible = false;
        that.sureCbInfo = false;
        /*console.log(that.insContId);*/
      },
      addMembers() {
        let num = this.socialList.length;
        /*console.log("socialList-num",num);*/
        let obj = {
          id: num,
          socialName: "",
          fwnr: "",
          fwnrId: "",
          idcard: "",
          startDate: "",
          monthNum: "",
          endDate: "",
          priceType: "",
          priceTypeId: ""
        };
        this.socialList.push(obj);
        this.sureCbInfo = false;
      },
      openServerPopup(index) {
        /*console.log(index);*/
        this.curSerIndex = index;
        this.socialList.map((item) => {
          /*console.log(item);*/
          if(item.id == index) {
            this.ServiceVisible = true;
          }
        });
      },
      selectService(picker, values) {
        /*console.log(this.curSerIndex);*/
        /*console.log("picker",picker);
        console.log("values",values);*/
        this.socialList.map((item) => {
          if(this.curSerIndex == item.id) {
            item.fwnr = `${values.name}`;
            item.fwnrId = values.id;
          }
        });
      },
      closeService() {
        let that = this;
        that.ServiceVisible = false;
      },
      sureService(values) {
        let that = this;
        this.socialList.map((item) => {
          if(this.curSerIndex == item.id) {
            if (item.fwnr == '') {
              item.fwnr = values.name;
            }
            if (item.fwnrId == '') {
              item.fwnrId = values.id;
            }
          }
        });
        that.ServiceVisible = false;
        that.sureCbInfo = false;
      },
      openDatePopup(val, index) {
        this.number = val;
        this.curSerIndex = index;
        var curDate = new Date();
        this.currentDate = curDate;
        this.socialList.map((item) => {
          /*console.log(item);*/
          if(item.id == index) {
            this.DateVisible = true;
            if(item.startDate != '' && val == 0) {
              this.currentDate = this.StrToGMT(item.startDate);
            }
            if(item.endDate != '' && val == 1) {
              this.currentDate = this.StrToGMT(item.endDate);
            }
          }
        });
      },
      closeDate() {
        let that = this;
        that.DateVisible = false;
      },
      sureDate() {
        this.socialList.map((item) => {
          if(this.curSerIndex == item.id) {
            if (item.startDate == ''&&this.number==0) {
              item.startDate = this.GMTToStr(this.currentDate);
            }
            if (item.endDate == ''&&this.number==1) {
              item.endDate = this.GMTToStr(this.currentDate);
            }
            item.monthNum = this.getmonthNumber(item.startDate, item.endDate);
          }
        });
        this.DateVisible = false;
        this.sureCbInfo = false;
      },
      GMTToStr(time) {
        //GMT转普通格式
        let date = new Date(time);
        let year = date.getFullYear();
        let month = (date.getMonth() + 1);
        if(month<10) {
          month = '0'+month;
        }
        let Str= year + '/' + month;
          /* + '-' +date.getDate() + ' ' +
          date.getHours() + ':' +
          date.getMinutes() + ':' +
          date.getSeconds()*/
        return Str;
      },
      StrToGMT(time) {
        //普通格式转GMT
        const second = '/01 00:00:00';
        time += second;
        let GMT = new Date(time);
        return GMT;
      },
      getmonthNumber(date1, date2) {
        //默认格式为"2020-12-10",根据自己需要改格式和方法
        var year1 = date1.substr(0, 4);
        var year2 = date2.substr(0, 4);
        var month1 = date1.substr(5, 2);
        var month2 = date2.substr(5, 2);
        var len = (year2 - year1) * 12 + (month2 - month1) + 1;
        /*var day = date2.substr(8, 2) - date1.substr(8, 2);*/
        /*if (day > 0) {
            len += 1;
        }else if (day < 0){
            len -= 1;
        }*/
        return len;
      },
      changeDate(num) {
        /*console.log("日期开始或者结束状态：",num);*/
        let curDate = this.currentDate;
        let strCurDate = this.GMTToStr(curDate);
        /*console.log("strCurDate",strCurDate);*/
        /*console.log(this.currentDate);*/
        this.socialList.map((item) => {
          if(this.curSerIndex == item.id) {
            if(num == 0) {
              item.startDate = strCurDate;
            } else {
              item.endDate = strCurDate;
            }
            item.monthNum = this.getmonthNumber(item.startDate, item.endDate);
          }
        });
      },
      openPricePopup(index) {
        this.curSerIndex = index;
        this.socialList.map((item) => {
          /*console.log(item);*/
          if(item.id == index) {
            this.priceVisible = true;
          }
        });
      },
      selectPrice(picker, values) {
        /*console.log(this.curSerIndex);*/
        /*console.log("picker",picker);
        console.log("values",values);*/
        this.socialList.map((item) => {
          if(this.curSerIndex == item.id) {
            item.priceType = `${values[0].childName}`;
            item.priceTypeId = values[0].id;
          }
        });
      },
      closePrice() {
        let that = this;
        that.priceVisible = false;
      },
      surePrice(values) {
        let that = this;
        this.socialList.map((item) => {
          if(this.curSerIndex == item.id) {
            if (item.priceType == '') {
              item.priceType = values.childName;
            }
            if (item.priceTypeId == '') {
              item.priceTypeId = values.id;
            }
          }
        });
        that.priceVisible = false;
        that.sureCbInfo = false;
      },
      hidePayDetail() {
        this.sureCbInfo = false;
      },
      sureInsInfo() {
        //确认参保信息
        if(this.cityCode == '' || this.cityCode == undefined) {
          this.$toast('请选择参保城市');
          return;
        }
        if (this.insContId == 0) {
          this.$toast('请选择参保内容');
          return;
        }
        if (this.contactTel == "") {
          this.$toast('请输入手机号码');
          return;
        } else if (this.contactTel.length != 11) {
          this.$toast('请输入正确的手机号码');
          return;
        } else if (!(/^1[3|4|5|7|8]\d{9}$/.test(this.contactTel))) {
          this.$toast('请输入正确的手机号码');
          return;
        }
        for(let i=0; i< this.socialList.length; i++) {
          //console.log("子项：",this.socialList[i]);
          if (this.socialList[i].socialName == '') {
            this.$toast("参保人" + (i + 1) + "，请输入姓名");
            return;
          } else if(!(/^[a-zA-Z\u4e00-\u9fa5]+$/.test(this.socialList[i].socialName))) {
            this.$toast("参保人" + (i + 1) + "，姓名只能输入中文和英文");
            return;
          } else if (this.socialList[i].idcard == '') {
            this.$toast("参保人" + (i + 1) + "，请输入身份证号");
            return;
          } else if (!(/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(this.socialList[i].idcard))) {
            this.$toast("参保人" + (i + 1) + "，请输入正确的身份证号");
            return;
          } else if (this.socialList[i].startDate == '') {
            this.$toast("参保人" + (i + 1) + "，请输入参保时间");
            return;
          } else if (this.socialList[i].endDate == '') {
            this.$toast("参保人" + (i + 1) + "，请输入参保时间");
            return;
          } else if (this.socialList[i].monthNum <= 0) {
            this.$toast('参保时间开始日期不能大于结束日期');
            return;
          } else if (this.socialList[i].fwnrId == 0) {
            this.$toast("参保人" + (i + 1) + "，请选择服务内容");
            return;
          } else if (this.socialList[i].priceTypeId === 0) {
            this.$toast("参保人" + (i + 1) + "，请选择缴纳类型");
            return;
          }
        }

        var socialInsuranceByDateDTO = {};
        var socialInsuranceIsIdAndMonthMums = [];
        this.socialList.map((item, i) => {
          var list = {};
          list.name = item.socialName;
          list.cityConfigId = item.priceTypeId;
          list.monthNum = item.monthNum;
          socialInsuranceIsIdAndMonthMums[i] = list;
        });

        socialInsuranceByDateDTO.provinceId = this.cityCode.province;
        socialInsuranceByDateDTO.cityId = this.cityCode.city;
        socialInsuranceByDateDTO.requestType = this.insContId;
        socialInsuranceByDateDTO.socialInsuranceIsIdAndMonthMums = socialInsuranceIsIdAndMonthMums;
        this.$Api.getPriceType(socialInsuranceByDateDTO).then(res => {
          /*console.log(res);*/
          if (res.code != 200) {
            this.$toast.fail(`${res.msg}`);
            this.sureCbInfo = false;
            return;
          }
          var payTypePriceVO = res.payTypePriceVO;
          this.charge = payTypePriceVO.collectionFee;
          this.serviceCharge = payTypePriceVO.serviceFee;
          this.totalPrice = payTypePriceVO.totalFee;
          this.sureCbInfo = true;
        }).catch(err => {
          this.$toast("服务器错误，请稍后重试！");
        });
      },
      toPay() {
        if(this.checked) {
          //console.log("协议同意，请支付");
          var socialInsuranceByDateDTO = {};
          var socialInsuranceIsIdAndMonthMums = [];
          var returnUrl = window.location.href;  //传给后台使用
          /*console.log("returnURL*************",returnUrl);*/
          this.socialList.map((item, index) => {
            var list = {};
            list.name = item.socialName;
            list.userId = item.idcard;
            list.monthNum = item.monthNum;
            list.buyMonth = item.startDate +"~"+ item.endDate;
            list.contentType = item.fwnrId;
            list.cityConfigId = item.priceTypeId;
            list.cityConfigName= item.priceType;
            socialInsuranceIsIdAndMonthMums[index] = list;
          });
          socialInsuranceByDateDTO.provinceId = this.cityCode.province;
          socialInsuranceByDateDTO.cityId = this.cityCode.city;
          socialInsuranceByDateDTO.requestType = this.insContId;
          socialInsuranceByDateDTO.phone = this.contactTel;
          socialInsuranceByDateDTO.cityName = this.cityName;
          socialInsuranceByDateDTO.socialInsuranceIsIdAndMonthMums = socialInsuranceIsIdAndMonthMums;
          socialInsuranceByDateDTO.returnUrl = returnUrl;
          this.$Api.gotoPay(socialInsuranceByDateDTO).then(res => {
            /*console.log(res);*/
            if (res.code == 500 || res.code == '500') {
              this.$toast.fail("提交订单失败，请稍后重试");
            } else {
              /*console.log('orderId:', res.orderId);*/
              this.$router.push({name: 'pay' ,query: { orderId: res.orderId }});
            }
          }).catch(err => {
            this.$toast("服务器错误，请稍后重试！");
          });
        } else {
          this.$toast("请先同意《亿企评服务协议》，再去支付！");
        }
      }
    },
    mounted() {
      //城市数据
      this.getCityData();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import "./Home.css";
</style>



// WEBPACK FOOTER //
// src/layout/Home/Home.vue